'use strict';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {firebaseAuthSuccess} from '../../auth/actions';
import {markCommentsRead, markCommentsReadSuccess, markCommentsReadError} from '../actions';
import {logger} from './logger';


export const epics = [
  onMarkCommentsRead,
];

onMarkCommentsRead.$inject = [
  'FirebaseUtil',
];

/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 * @return {Observable<ReduxAction>}
 */
export function onMarkCommentsRead(action$, store, dependencies) {
  return action$.ofType(firebaseAuthSuccess.TYPE)
    .map(action => action.payload.userId)
    .switchMap(userId => !userId ? Observable.empty() :
      action$.ofType(markCommentsRead.TYPE)
        .distinctUntilChanged(null, action => `${action.payload.id}+${action.payload.count}`)
        .mergeMap(action => updateMetrics(userId, action))
    )
    .catch(epicErrorHandler(logger, 'onLoadSubscriptions'));

  function updateMetrics(userId, action) {
    if (isString(action.payload.id) && isNumber(action.payload.count) && isFinite(action.payload.count)) {
      return dependencies.FirebaseUtil.set([
        'users-meta',
        userId,
        'links',
        'conversation-metrics',
        action.payload.id,
        'readComments',
      ].join('/'), action.payload.count)
        .then(() => markCommentsReadSuccess(action.payload.id))
        .catch(e => markCommentsReadError(action.payload.id, e));
    } else {
      return markCommentsReadError(action.payload.id, new Error('required a number and a conversation ID'));
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/comments/epics/onMarkCommentsRead.js